export const WORKING_MODE_STANDARD = 'WORKING_MODE_STANDARD';
export const WORKING_MODE_POWER_ANALYSIS = 'WORKING_MODE_POWER_ANALYSIS';
